export * from './Slider';
export * from './Slider.decl';